import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { hideNotification } from '../../store/actions/notification';
import DashboardLayout from './../layout/Dashboard';
import { FormattedMessage } from 'react-intl';
import { Messages } from "../../components/layout/Messages/Messages";
import { NOTIFICATION_ORDER_ACTIONS } from '../../config/notifications';
import { getOrganizations as getOrganizationsApi } from '../../api/clients/organizations';
import { getProductGroups as getProductGroupsApi } from '../../api/clients/productGroups';
import { CreateOrderForm } from '../../components/pages/orderManagement/createOrder/CreateOrderForm';
import { ACL, PRODUCT_GROUPS } from '../../config/constants';
import { NoRights } from '../../components/layout/Permissions/NoRights';
import {
  PageHeader,
  PageSurface,
  PageWorkspace
} from '../../components/layout/Workspace';
import './CreateOrder.scss';


function CreateOrderComponent(props) {
  const [ organizations, setOrganizations ] = useState( [] );
  const [ productGroups, setProductGroups ] = useState( [] );
  const [ organizationsLoaded, setOrganizationsLoaded ] = useState( false );

  useEffect( () => {
    getOrganizations();
  }, [] ); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect( () => {
    if (! organizations.length) {
      return;
    }

    getProductGroups();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ organizationsLoaded ] );

  const getOrganizations = () => {
    if (! ACL.CLIENT.ORDERS.CREATE.hasAccess()) {
      return;
    }

    getOrganizationsApi( {
      disablePagination: true
    } ).then( response => {
      if (! response || ! response.data) {
        return;
      }

      setOrganizations( response.data );
      setOrganizationsLoaded( true );
    } );
  }

  const getProductGroups = () => {
    if (! ACL.CLIENT.ORDERS.CREATE.hasAccess()) {
      return;
    }

    getProductGroupsApi( {
      disablePagination: true
    } ).then( response => {
      if (! response || ! response.data) {
        return;
      }

      let formattedProductGroups = [];
      // sort and format product groups
      Object.keys( PRODUCT_GROUPS ).forEach( key => {
        if (! PRODUCT_GROUPS[key].active) {
          return;
        }

        response.data.forEach( item => {
          if (item.name === PRODUCT_GROUPS[key].name) {
            formattedProductGroups.push( {
              ...item,
              text: PRODUCT_GROUPS[key].text
            } );
            return;
          }
        } );
      } );

      setProductGroups( formattedProductGroups );
    } );
  }

  return (
    <DashboardLayout
      pageTitle={<FormattedMessage id="app.dashboard.page_title"/>}
      workspace
      {...props}
    >
      <PageWorkspace className="create-order-workspace">
        <PageHeader title={<FormattedMessage id="pages.createOrder.title"/>}/>
        <div className="create-order-notifications">
          <Messages/>
          <Messages notificationId={NOTIFICATION_ORDER_ACTIONS}/>
        </div>
        <PageSurface className="create-order-surface">
          {ACL.CLIENT.ORDERS.CREATE.hasAccess() ? <CreateOrderForm
              organizations={organizations}
              productGroups={productGroups}
            /> : <NoRights/>}
        </PageSurface>
      </PageWorkspace>
    </DashboardLayout>
  );
};

const mapActionsToProps = {
  hideNotification
};

const CreateOrder = connect( null, mapActionsToProps )( CreateOrderComponent );

export { CreateOrder, CreateOrderComponent };
